/**
 * Public client configuration (embedded at build time).
 * Only variables prefixed with VITE_ are exposed — same security model as CRA's REACT_APP_*.
 * @see https://vitejs.dev/guide/env-and-mode.html
 */
const env = import.meta.env;

export const API_URL = env.VITE_API_URL ?? env.VITE_APP_API_URL ?? "";
export const CLIENT_ID = env.VITE_CLIENT_ID ?? "";
export const CLIENT_SECRET =
  env.VITE_CLIENT_SECRET ?? env.VITE_APP_CLIENT_SECRET ?? "";
export const APP_ENV = env.VITE_APP_ENV ?? "";

// Quota Next Period
export const POWERBI_REPORT_ID_QNP =
  env.VITE_APP_POWERBI_REPORT_ID_QNP ?? env.VITE_POWERBI_REPORT_ID_QNP ?? "";
export const POWERBI_GROUP_ID_QNP =
  env.VITE_APP_POWERBI_GROUP_ID_QNP ?? env.VITE_POWERBI_GROUP_ID_QNP ?? "";
export const POWERBI_DATASET_ID_QNP =
  env.VITE_APP_POWERBI_DATASET_ID_QNP ?? env.VITE_POWERBI_DATASET_ID_QNP ?? "";

// Quota Running Period
export const POWERBI_REPORT_ID_QRP =
  env.VITE_APP_POWERBI_REPORT_ID_QRP ?? env.VITE_POWERBI_REPORT_ID_QRP ?? "";
export const POWERBI_GROUP_ID_QRP =
  env.VITE_APP_POWERBI_GROUP_ID_QRP ?? env.VITE_POWERBI_GROUP_ID_QRP ?? "";
export const POWERBI_DATASET_ID_QRP =
  env.VITE_APP_POWERBI_DATASET_ID_QRP ?? env.VITE_POWERBI_DATASET_ID_QRP ?? "";

// Analyze - Quota Modifications
export const POWERBI_REPORT_ID_QM =
  env.VITE_APP_POWERBI_REPORT_ID_QM ?? env.VITE_POWERBI_REPORT_ID_QM ?? "";
export const POWERBI_GROUP_ID_QM =
  env.VITE_APP_POWERBI_GROUP_ID_QM ?? env.VITE_POWERBI_GROUP_ID_QM ?? "";
export const POWERBI_DATASET_ID_QM =
  env.VITE_APP_POWERBI_DATASET_ID_QM ?? env.VITE_POWERBI_DATASET_ID_QM ?? "";

// Analyze - Supply and Demand Data
export const POWERBI_REPORT_ID_SDD =
  env.VITE_APP_POWERBI_REPORT_ID_SDD ?? env.VITE_POWERBI_REPORT_ID_SDD ?? "";
export const POWERBI_GROUP_ID_SDD =
  env.VITE_APP_POWERBI_GROUP_ID_SDD ?? env.VITE_POWERBI_GROUP_ID_SDD ?? "";
export const POWERBI_DATASET_ID_SDD =
  env.VITE_APP_POWERBI_DATASET_ID_SDD ?? env.VITE_POWERBI_DATASET_ID_SDD ?? "";
